import { useState } from 'react';
import { SessionFormDialogState } from 'src/app/modules/event-v2/types';

export const useSessionSetting = () => {
  const [formDialogState, setFormDialogState] = useState<SessionFormDialogState>({ open: false });

  return { formDialogState, setFormDialogState };
};
